<template>
  <div class="home-redesign home-redesign-variant home-redesign-variant--a">
    <div class="hrv-page-bg" aria-hidden="true">
      <div class="hrv-page-bg__layer hrv-page-bg__layer--art" :style="bgArtStyle" />
      <div class="hrv-page-bg__layer hrv-page-bg__layer--wash" />
    </div>
    <main class="hrv-page-main">
      <HrHeroSplitStats :data="hero" :stats="heroStats" />
      <HrQuickLinks :items="quickLinks" :show-title="false" />
      <HrAboutStats :about="about" :stats="stats" :show-stats="false" />
      <HrDirections :items="directions" />
      <HrReviewsNews :review="review" :news="newsBlock" />
      <HrAdvantages :items="advantages" />
      <HrClosingBanners />
    </main>
  </div>
</template>

<script>
import '@/assets/scss/views/home-redesign.scss'
import '@/assets/scss/views/home-redesign-variants.scss'

import HrHeroSplitStats from './HrHeroSplitStats.vue'
import HrQuickLinks from '../components/HrQuickLinks.vue'
import HrAboutStats from '../components/HrAboutStats.vue'
import HrDirections from '../components/HrDirections.vue'
import HrReviewsNews from '../components/HrReviewsNews.vue'
import HrAdvantages from '../components/HrAdvantages.vue'
import HrClosingBanners from '../components/HrClosingBanners.vue'

import pageBgArt from '@/assets/img/home-redesign/page-bg-soft.png'

import {
  heroA,
  heroStatsA,
  quickLinks,
  about,
  stats,
  directions,
  review,
  newsBlock,
  advantages,
} from './variantData'

export default {
  name: 'IndexRedesignA',
  components: {
    HrHeroSplitStats,
    HrQuickLinks,
    HrAboutStats,
    HrDirections,
    HrReviewsNews,
    HrAdvantages,
    HrClosingBanners,
  },
  metaInfo() {
    return {
      title: 'Главная | Перинатальный центр ДАР',
    }
  },
  data() {
    return {
      hero: heroA,
      heroStats: heroStatsA,
      quickLinks,
      about,
      stats,
      directions,
      review,
      newsBlock,
      advantages,
      bgArtStyle: {
        backgroundImage: `url(${pageBgArt})`,
      },
    }
  },
  mounted() {
    document.documentElement.style.scrollBehavior = 'smooth'
  },
}
</script>
